const elementCache = new Map<string, HTMLElement | null>();

export function hudEl(id: string): HTMLElement | null {
  let el = elementCache.get(id);
  if (el === undefined) {
    el = document.getElementById(id);
    elementCache.set(id, el);
  }
  return el;
}
